import React from "react";
import ReactHtmlParser from "react-html-parser";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { transformLink } from "../../../helpers/";
import { graphql } from "gatsby";
import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

export const CoreParagraphBlock = (props) => {
  const classes = useStyles();

  let style = {};
  // If there is a backgroundColor set, add padding and color
  // todo - this needs linking to the primary/secondary colors and padding of the theme, better by class?
  //if(props.attributes.backgroundColor !== null){
  //    style = {
  //        backgroundColor: '#cccccc',
  //        padding: '24px'
  //    }
  //}

  return (
    <React.Fragment>
      {props.attributes.anchor !== "" && (
        <a id={`${props.attributes.anchor}`}></a>
      )}
      <p
        color="initial"
        align={props.attributes.align ? props.attributes.align : "left"}
        className={props.attributes.className + " " + classes.para}
        style={style}
        data-text-color={
          props.attributes.textColor ? props.attributes.textColor : "initial"
        }
      >
        {ReactHtmlParser(props.attributes.content, {
          transform: transformLink,
        })}
      </p>
    </React.Fragment>
  );
};

CoreParagraphBlock.propTypes = {
  attributes: PropTypes.object.isRequired,
};

// This is the GraphQL Fragment that will be used within Gatsby queries
export const CoreParagraphBlockFragment = graphql`
  fragment CoreParagraphBlock on WpBlock {
    ... on WpCoreParagraphBlock {
      name
      attributes {
        __typename
        ... on WpCoreParagraphBlockAttributes {
          anchor
          backgroundColor
          textColor
          className
          align
          direction
          content
        }
      }
    }
  }
`;

export const CoreParagraphBlockPreview = `
  ... on CoreParagraphBlock {
    name
    attributes {
      __typename
      ... on CoreParagraphBlockAttributes {
        anchor
        backgroundColor
        textColor
        className
        align
        direction
        content
      }
    }
  }
  `;
